import { KickerLine } from "@motleyhand/design"

export default function Hero() {
  return (
    <section className="mx-auto max-w-3xl px-6 pt-24 pb-16 text-center sm:pt-28 sm:pb-28">
      <h1 className="text-xl text-foreground/80 sm:text-2xl">
        The platform for building&nbsp;on&nbsp;AI.
      </h1>
      <p className="mt-8 mb-10 font-title text-5xl leading-[1.1] font-medium tracking-tight sm:mt-10 sm:mb-12 sm:text-6xl md:text-7xl">
        Tame the AI circus.
      </p>
      <div className="mt-10 text-lg text-muted-foreground sm:mt-12">
        <KickerLine
          className="justify-center text-lg"
          items={[
            "Author prompts",
            "Build workflows",
            "Evaluate quality",
            "Run at scale",
          ]}
        />
        <p className="mt-2 text-foreground/80">One platform.</p>
      </div>
    </section>
  )
}
